export default __webpack_public_path__ + "static/media/img11.74c7e5ab.PNG";